import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="case_studies" pageTitle="Casos de éxito" pageDescription="Ejemplos reales de cómo QbD Group ayuda a empresas de Life Sciences a superar retos regulatorios y acelerar el lanzamiento al mercado." />;

export const Route = createFileRoute("/es/casos-de-exito/")({
  head: () => buildRouteHead("/es/casos-de-exito"),
  component: ContentListingRoute,
});

